var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-radio-group',
    {
      'dp-radio-group--list': _vm.list,
    } ],attrs:{"role":"group","aria-label":"radio-group"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }